import React, { FunctionComponent, ReactNode } from "react";
import { Typography } from "@material-ui/core";
import "./index.scss";
import { Link } from "../../config/components";
import { Variant as ThemeVariant } from "@material-ui/core/styles/createTypography";

import {
  Space,
  SpaceAmenity,
  SpaceAmenityType,
} from "../../services/entities/spaces";
import {
  AirConditioningIcon,
  CashDeskIcon,
  FittingRoomIcon,
  HeatingIcon,
  LightingIcon,
  ShelvingIcon,
  SpeakersIcon,
  StockRoomIcon,
  ToiletsIcon,
  WheelchairAccessIcon,
  WifiIcon,
} from "components/Icon";

type Variant = ThemeVariant | "srOnly";

interface BackgroundAssetPosition {
  top?: string | any;
  right?: string | any;
  bottom?: string | any;
  left?: string | any;
}

type PanelAmentiesProps = {
  title?: string | any;
  text?: string | any;
  code?: string | any;
  backgroundAsset?: string;
  backgroundAssetPosition?: BackgroundAssetPosition;
  backgroundAssetSize?: string;
  index?: number;
  imageLeft?: boolean;
  sectionTitle?: string | any;
  highlightedText?: string | any;
  link?: Link | undefined;
  titleVariant?: Variant | "inherit";
  sectionPadding?: string | any;
  space: Space;
  value?: number;
  i?: number;
  key: string;
};

type AmentyProps = {
  name: string | SpaceAmenity;
  type: SpaceAmenityType;
  icon: ReactNode;
};

export const PanelAmenties: FunctionComponent<PanelAmentiesProps> = ({
  title,
  text,
  code,
  backgroundAsset,
  backgroundAssetPosition = {
    top: "0px",
    bottom: "0px",
    left: "0px",
    right: "0px",
  },
  backgroundAssetSize,
  index,
  sectionTitle,
  highlightedText,
  link,
  titleVariant = "h1",
  sectionPadding,
  space,
  value,
  i,
}) => {
  const Amenity: FunctionComponent<AmentyProps> = ({ name, type, icon }) => {
    return (
      <div className="amenity-tile">
        {icon}
        <Typography
          variant="subtitle1"
          component="p"
          className="title"
          dangerouslySetInnerHTML={{
            __html: name.toString(),
          }}
        />
      </div>
    );
  };

  const renderAmenities = (space: Space) => {
    let icon = null;
    let name = null;
    const list = (space.amenities as SpaceAmenity[]).map(
      (item: SpaceAmenity) => {
        switch (item.type) {
          case SpaceAmenityType.FittingRoom:
            icon = <FittingRoomIcon />;
            name = "Fitting Room";
            break;
          case SpaceAmenityType.CashDesk:
            icon = <CashDeskIcon />;
            name = "Cash Desks";
            break;
          case SpaceAmenityType.AdjustableShelving:
            icon = <ShelvingIcon />;
            name = "Adjustable Shelving";
            break;
          case SpaceAmenityType.Lighting:
            icon = <LightingIcon />;
            name = "Lighting";
            break;
          case SpaceAmenityType.ColoredLighting:
            icon = <LightingIcon />;
            name = "Coloured Lighting";
            break;
          case SpaceAmenityType.Heating:
            icon = <HeatingIcon />;
            name = "Heating";
            break;
          case SpaceAmenityType.Wifi:
            icon = <WifiIcon />;
            name = "Wifi";
            break;
          case SpaceAmenityType.AirConditioning:
            icon = <AirConditioningIcon />;
            name = "Air Conditioning";
            break;
          case SpaceAmenityType.Toilets:
            icon = <ToiletsIcon />;
            name = "Toilets";
            break;
          case SpaceAmenityType.StockRoom:
            icon = <StockRoomIcon />;
            name = "Stock Room";
            break;
          case SpaceAmenityType.WheelchairAccess:
            icon = <WheelchairAccessIcon />;
            name = "Wheelchair Access";
            break;
          case SpaceAmenityType.Speakers:
            icon = <SpeakersIcon />;
            name = "Speakers";
            break;
        }

        return <Amenity name={name} type={item.type} icon={icon} key={name} />;
      }
    );
    return list;
  };
  return (
    <section
      className={`panel-amenity`}
    >
      {sectionTitle && (
        <Typography
          
          component="h2"
          className="section-title"
        >
          {sectionTitle}
        </Typography>
      )}

      {title && (
        <Typography
          variant="subtitle1"
          component="h2"
          className="title"
          dangerouslySetInnerHTML={{
            __html: title.toString(),
          }}
        />
      )}
      <div className="amentity-tiles">{renderAmenities(space)}</div>
    </section>
  );
};

export default PanelAmenties;
